<template>
    <b-table
        :data="records"
        :striped="true"
        :loading="loading"
        :mobile-cards="true"

        backend-pagination
        :total="total"
        :per-page="perPage"
        @page-change="onPageChange"
        backend-sorting
        :default-sort-direction="sortOrder"
        :default-sort="[sortField, sortOrder]"
        @sort="onSort"

        :paginated="paginated"
        :sort-icon="'chevron-up'"
    >
        <template>
            <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="!_.isNull(props.row.organisation) && user && user.role == 'pit'">
                    {{ organisations[props.row.organisation].short_name }}
                </b-button>
                <span v-else>
                    Basis
                </span>
            </b-table-column>

            <b-table-column v-slot="props" field="type" label="Type" sortable>
                {{ props.row.type == 'agreement' ? 'Overeenkomst' : props.row.type == 'general' ? 'Algemeen' : props.row.type }}
            </b-table-column>

            <b-table-column v-slot="props" field="title" label="Titel" sortable>
                {{ props.row.title }}
            </b-table-column>

            <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" width="220" sortable>
                <span>{{ props.row.updated_at|humanDate }}</span>
            </b-table-column>

            <b-table-column v-slot="props" numeric width="100">
                <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'ContractsTemplateRecord', params: {id: props.row.id} }">Aanpassen</b-button>
            </b-table-column>
        </template>

        <template #empty>
            <section class="section">
                <div class="content has-text-grey has-text-centered">
                    <p class="margin0" v-if="loading === false">Geen contract sjablonen gevonden.</p>
                    <p class="margin0" v-else>Laden...</p>
                </div>
            </section>
        </template>
    </b-table>
</template>


<script>
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'ContractsTemplatesTable',
    mixins: [filtersMixin, paramsMixin],

    data () {
        return {
            records: [],

            total: null,
            loading: false,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 20,
            searchParams: typeof(this.$store.state.searchQueries['ContractsTemplates']) != 'undefined' ? this.$store.state.searchQueries['ContractsTemplates'] : null
        }
    },

    computed: {
        paginated(){
            return this.records.length < this.total
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        }
    },

    methods: {
        loadAsyncData() {
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, 'ContractsTemplates')

            this.loading = true
            this.$emit('passLoading', true)

            axios.get(`/api/contract-templates?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: 'ContractsTemplates', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching contract templates:', error)
                this.data = []
                this.total = null
            }).then(() => {
                this.loading = false
                this.searchParams = null

                this.$emit('passTotal', this.total)
                this.$emit('passLoading', false)
            })
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        }
    }
}
</script>